module.exports = __webpack_public_path__ + "static/media/addlogoimg.f59484e7.png";